export default "__VITE_ASSET__628b0df0__"